<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Nova exportação"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.anos"
                        :validations="validations.ano"
                        @change="handleAnoChange"
                        label="Ano"
                        show-default-option
                        text-field="ano"
                        v-model="model.ano"
                        value-field="ano"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.meses"
                        :validations="validations.mes"
                        label="Mês"
                        show-default-option
                        text-field="mes"
                        v-model="model.mes"
                        value-field="mes"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Gerar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {
            return {
                ano: { required: true },
                mes: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('imunizacao.exportacao'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.exportacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        open() {
            this.load()
            this.$refs.RkmModal.show()
        },
        handleAnoChange(value) {
            this.form.meses = null
            this.model.mes = null

            if (value) {
                this.getMeses(value)
            }
        },
        getMeses(ano) {
            const request = {
                listar: 'meses',
                ano: ano,
            }

            this.setLoading()

            this.repositories.exportacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {                    
                    this.form.meses = Object.assign(response.data)
                    
                    if (this.form.meses.length === 1) {
                        const selected = this.form.meses[0]
                        this.model.mes = selected.mes
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    this.repositories.exportacao.store(this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('save', response)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>